import { TextField } from '@mui/material';
import styled from 'styled-components';
import { colorTheme } from './muiTheme';

export const FileInput = styled(TextField)`
display: none;
`;

export const SearchTextInput = styled(TextField)`&& {
  .MuiInputBase-input {
    color: ${colorTheme.palette.primary.main};
    font-size: 13px;
    font-weight: 600;
    padding: 6px 40px 6px 6px;
  }
}`;

export const StyledArrow = styled('span')<{ open: boolean }>(({ open }) => ({
  transition: 'transform 0.3s ease-in-out',
  transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  display: 'inline-flex',
  verticalAlign: 'middle',
  color: `${colorTheme.palette.common.black}`
}));